import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "MainFooter",
  data() {
      return {
          user: {}, 
          user_slug: {},
          this_year: service.thisYear,
      }
  }
 
}


// WEBPACK FOOTER //
// ./src/components/Main-Footer/script.js